import { faBox, faFilePdf, faFloppyDisk, faPen, faRectangleXmark, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { EDITAR_NOTAS_PRIVADAS } from "../../utils/permisos";
import activoContext from '../../context/activoContex/activoContex';

import './ConsumoInfo.css';

const ConsumoInfo = ({item, cerrar, verDetalle, usuario,generaPDF}) =>{

    const [consumo, setConsumo] = useState(item);
    const {activoList} = useContext(activoContext);
    
    const activo = useMemo(()=>{
        return activoList?.find(a => item.activoID == a._id);
    },[item,activoList]);

    /*
        Al renderizar el componente, recupera los productos del consumo seleccionado.
    */
    useEffect(() => {
        async function fp() {
            try {
                const p = await verDetalle(item.tDocCodFor, item.tDocNroFor);
                setConsumo({...consumo, products: p});
            } catch (error) {
                console.log("error");
            }
        }
        fp();
    }, []);

    return (
            <div className='container-gr-req consumoInfo'>
                <div className='container-r-list-item-header-info'>
                    <div className='label-req'>{consumo.tDocCodFor + ' - ' + consumo.tDocNroFor}</div>
                    <div className='r-list-item-header-title'>{consumo.title}</div>
                    <button className="minimizarBtn" onClick={() => cerrar(null)}>X</button>
                </div>
                <div className='container-r-item-details'>
                    <div className='container-r-info-p'>
                        <div className="mainInfoCons">
                            <div className='label-req-title'>Activo</div>
                            <div className='r-list-item-details-title-v'>{activo.name}</div>
                        </div>
                        <div className="mainInfoCons">
                            <div className='label-req-title'>Emitido por </div>
                            <div className='r-list-item-details-title-v'>{consumo.userName}</div>
                        </div>
                    </div>
                    <div className='container-r-item-title-details'>Info Adicional</div>
                    <div className='container-r-texto'>
                        <div className='r-list-item-details-data-v'>{consumo.observ}</div>
                    </div>

                    <div className='container-r-item-title-details'>Fecha</div>
                    <div className='container-r-fecha'>
                        <div className='label-req-fecha'><div className='r-list-item-details-data-v'>Alta </div><div className='r-list-item-details-fecha-v'>{moment(consumo.fecAlt).format('DD-MM-YYYY')}</div></div>
                        <div className='label-req-fecha'><div className='r-list-item-details-data-v'>Movimiento </div><div className='r-list-item-details-fecha-v'>{moment(consumo.deliveryDate).format('DD-MM-YYYY')}</div></div>
                    </div>
                    
                    <div className='container-r-item-title-details'>Duración</div>
                    <div className='container-r-fecha duracionContainer'>
                        <div className='label-req-fecha'><div className='r-list-item-details-data-v'>Inicio </div><div className='r-list-item-details-fecha-v'>{moment(consumo.fecInicio).format('DD-MM-YYYY')}</div></div>
                        <div className='label-req-fecha'><div className='r-list-item-details-data-v'>Fin </div><div className='r-list-item-details-fecha-v'>{moment(consumo.fecFin).format('DD-MM-YYYY')}</div></div>
                        <div className='indicador indicador3'></div>
                        <div className='label-req-duracionCons'><div className='r-list-item-details-fecha-v'>{consumo.cantDias} días</div></div>
                    </div>
    
                    <div className='container-r-item-title-details'>Materiales: {consumo?.products?.length ?? 0}</div>
                    <div className="container-list-products-r-gral">
                        {(consumo.products != undefined) && consumo.products.map((product) => {
                            return (
                                <div className="container-list-products-r" key={product.codRed}>
                                    <div className="container-list-product-r-icon">
                                        <div className='list-item-icon-r'><FontAwesomeIcon icon={faBox} /></div>
                                        <div className="list-item-title-r">
                                            {product.codRed}
                                        </div>
                                    </div>
                                    <div className="container-list-products-r-details">
                                        <div>
                                            {product.descrp}
                                        </div>
                                        <div>
                                            {`${product.textAdic ? `${product.textAdic} - ` : ''} ${product.promedioDia > 0 ? `Promedio por día: ${product.promedioDia}` : ''}`}
                                        </div>
                                        <div className="container-cantidad-product-r">
                                            Cantidad: {product.quantity}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    
                </div>
                <div className="rq-container-buttons-bottom">
                    <div className="rq-button-bottom" onClick={() => generaPDF(consumo.tDocCodFor,consumo.tDocNroFor)} ><FontAwesomeIcon icon={faFilePdf} /> PDF</div>
                </div>
            </div>
        );

}

export default ConsumoInfo;

